import type { StaffingStepAggregates } from '@/util/vexo';

import type { JobDraftV2 } from '../context';

export type OvertimeWarningCounters = {
  shown: number;
  accepted: number;
  dismissed: number;
};

// Builds the Vexo `staffing_aggregates` payload that rides on
// `order_creation_step_completed` when the admin leaves step 2 (Staffing).
// Sums invite/hire counts across every job in the draft (one operation per
// invite, so a worker invited to two jobs counts twice) and reflects the
// current OT-warning counter snapshot. Pure on purpose so the wizard's
// `handleContinue` stays a one-liner and the math is unit-testable
// without mounting the full wizard.
export const buildStaffingAggregates = (
  jobs: ReadonlyArray<Pick<JobDraftV2, 'invite_workers' | 'hire_workers'>>,
  otCounters: OvertimeWarningCounters,
): StaffingStepAggregates => ({
  total_invited: jobs.reduce((n, j) => n + (j.invite_workers?.length ?? 0), 0),
  total_hired: jobs.reduce((n, j) => n + (j.hire_workers?.length ?? 0), 0),
  overtime_warnings_shown: otCounters.shown,
  overtime_warnings_accepted: otCounters.accepted,
  overtime_warnings_dismissed: otCounters.dismissed,
});
